<script setup>
import { BModal, BButton, BTabs, BTab, BRow, BCol, BFormInput, BFormSelect, BFormTextarea, BTable, BBadge} from 'bootstrap-vue-next';
import { ref,defineModel, defineProps } from 'vue'

defineProps({
    title : String,
    itemDis : Array,
    optionRoomType : Array,
    optionRoomNumber : Array,
    togle : Boolean

})


const itemInRoom = defineModel('itemInRoom')
const togle=ref(false)
const selectedRoomType = ref('Select Type')
const selectedRoomNumber = ref('Select Room')
</script>

<template>
<BModal id="modal-tall" :model-value="togle" centered :title="title" @update:modelValue="updateModal" size="lg"> 
    <BTabs content-class="mt-3">
        <BTab BTab title="Distribute" active>
            <BRow>
                <BCol v-for="(item,index) in itemDis" :key="index" >
                    <BBadge
                    class="w-100"
                    :class="item.type=='Family'?'bg-orange':item.type=='Studio'?'bg-success':item.type=='Deluxe'?'bg-danger':item.type=='Honey Moon'?'bg-primary':''"
                    >
                    <h6>
                        {{ item.type }}
                    </h6></BBadge>

                    <BTable stacked :items="item.room" >
                    
                    <template #cell()="data">
                        <div class="text-center ">
                        <BFormInput type="number" v-model="itemInRoom[data.field.key]"  ></BFormInput>
                        </div>
                    </template>
                    </BTable>
                </BCol>
            </BRow>
                    
        </BTab>

        <!-- Tab spoil -->
        <BTab title="Defact">
            <BRow>
                <BCol>
                    <BFormSelect :options="optionRoomType" v-model="selectedRoomType"></BFormSelect>
                </BCol>
                <BCol>
                    <BFormSelect :options="optionRoomNumber" v-model="selectedRoomNumber"></BFormSelect>
                </BCol>
            </BRow>
    
            <BRow class="mt-3">
                <BCol>
                    <BFormInput type="number"   placeholder="Total Defact "></BFormInput> 
                </BCol>
            </BRow>
        
            <BFormTextarea class="mt-3" placeholder="Remark"></BFormTextArea>
        </BTab>
    </BTabs>

    <template #footer>
        <div class="d-flex justify-content-end">
            <BButton variant="primary" @click="togle = false" class="mr-2">Save</BButton>
            <BButton variant="danger" @click="togle = false">Cancel</BButton>
        </div>
    </template>
        
</BModal>
</template>